import { useEffect, useState } from "react";
import { api } from "../lib/api";
import SeriesCard from "../components/SeriesCard";
import VideoCard from "../components/VideoCard";
import { Search as SearchIcon } from "lucide-react";

const GENRES = ["Crime", "Comedy", "Education", "Business", "CGI", "AI Ads", "Motivation", "Technology", "Storytelling"];

export default function Search() {
    const [q, setQ] = useState("");
    const [genre, setGenre] = useState(null);
    const [res, setRes] = useState({ series: [], viral: [], ai_creative: [] });

    useEffect(() => {
        const t = setTimeout(() => {
            const params = {};
            if (q) params.q = q;
            if (genre) params.genre = genre;
            api.get("/search", { params }).then((r) => setRes(r.data));
        }, 250);
        return () => clearTimeout(t);
    }, [q, genre]);

    return (
        <div data-testid="search-page" className="pt-28 pb-16 mx-auto max-w-[1600px] px-6 lg:px-10">
            <div className="max-w-3xl">
                <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tight">Search</h1>
                <div className="mt-6 relative">
                    <SearchIcon className="w-5 h-5 absolute left-4 top-1/2 -translate-y-1/2 text-white/50" />
                    <input
                        data-testid="search-input"
                        autoFocus
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        placeholder="Search series, episodes, videos…"
                        className="w-full bg-white/5 border border-white/10 rounded-full pl-12 pr-4 py-4 text-lg text-white focus:border-[#FFD400] outline-none transition-colors"
                    />
                </div>
                <div className="mt-4 flex gap-2 flex-wrap">
                    <button
                        onClick={() => setGenre(null)}
                        data-testid="search-genre-all"
                        className={`text-xs font-semibold px-3 py-1.5 rounded-full transition-colors ${
                            !genre ? "bg-[#FFD400] text-black" : "bg-white/5 text-white/80 border border-white/10 hover:bg-white/10"
                        }`}
                    >
                        All
                    </button>
                    {GENRES.map((g) => (
                        <button
                            key={g}
                            data-testid={`search-genre-${g.toLowerCase().replace(/\s+/g, "-")}`}
                            onClick={() => setGenre(g === genre ? null : g)}
                            className={`text-xs font-semibold px-3 py-1.5 rounded-full transition-colors ${
                                genre === g ? "bg-[#FFD400] text-black" : "bg-white/5 text-white/80 border border-white/10 hover:bg-white/10"
                            }`}
                        >
                            {g}
                        </button>
                    ))}
                </div>
            </div>

            {res.series.length > 0 && (
                <section className="mt-12">
                    <h2 className="font-display font-bold text-2xl mb-4">Series</h2>
                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6">
                        {res.series.map((s) => <SeriesCard key={s.id} series={s} />)}
                    </div>
                </section>
            )}

            {res.viral.length > 0 && (
                <section className="mt-12">
                    <h2 className="font-display font-bold text-2xl mb-4">Viral Videos</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        {res.viral.map((v) => <VideoCard key={v.id} video={v} />)}
                    </div>
                </section>
            )}

            {res.ai_creative.length > 0 && (
                <section className="mt-12">
                    <h2 className="font-display font-bold text-2xl mb-4">AI Creative</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                        {res.ai_creative.map((v) => <VideoCard key={v.id} video={v} kind="ai" />)}
                    </div>
                </section>
            )}

            {res.series.length === 0 && res.viral.length === 0 && res.ai_creative.length === 0 && (
                <p className="mt-12 text-white/50" data-testid="search-empty">No results. Try a different query or genre.</p>
            )}
        </div>
    );
}
